<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-10 15:45:12
-->
<template>
  <div style="background:#fff">
    <div v-for="(v, i) in aData" :key="i" class="item f-bt p-tb-20">
      <div>{{ v.CardTypeName }}</div>
      <div class="f">
        <span class="m-r-10">余额</span>
        <span class="m-r-20">
          {{ v.LeaveMoney + v.DonationMoney }}
        </span>
        
        <div v-if="payPrice>v.LeaveMoney + v.DonationMoney" class="disabled_radio" style="width:16px;height:16px" @click="handleShowTips">
          
        </div>
        <van-radio :name="v.Id" @click="radioChange(i)" v-else>
          <template #icon="props">
              <img
                style="width: 20px"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </van-radio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemberList",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    payPrice:{
      type: Number,
      default:0
    }
  },
  watch: {
    list(arr) {
      this.aData = arr;
    },
  },
  data() {
    return {
      aData: this.list,
      activeIcon: require("@/assets/radio/radio-active.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive.png"),
    };
  },
  components: {},
  created() {
  },
  mounted() {},
  methods: {
    radioChange(i) {
      
      this.$emit("click", this.aData[i]);
    },
    handleShowTips(){
      this.$toast("该会员卡余额不足");
    }
  },
};
</script>
<style scoped lang="scss">
.disabled_radio{
  // width: 20px;
  // height: 20px;
  border-radius: 50%;
  background-color: rgb(207, 207, 207);
    border-color: #999;
    margin-right: 2px;
}
</style>
